module.exports = __webpack_public_path__ + "static/media/technocate_1_desktop.49bd8e41.png";